import Link from '@mui/material/Link';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import typography from 'assets/theme/base/typography';
import { useIntl } from 'react-intl';

function Footer() {
  const { formatMessage: msg } = useIntl();

  const { size } = typography;

  const links = [
    {
      href: msg({ id: 'company.website' }),
      name: msg({ id: 'company.name' })
    },
    {
      href: msg({ id: 'about.website' }),
      name: msg({ id: 'about.name' })
    }
  ];

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography variant="button" fontWeight="regular" color="text">
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
      mt={1}
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        &copy; {new Date().getFullYear()}
        <Link href={msg({ id: 'product.website' })} target="_blank">
          <MDTypography variant="button" fontWeight="medium">
            &nbsp;{msg({ id: 'product.name' })}&nbsp;
          </MDTypography>
        </Link>
      </MDBox>
      <MDBox
        component="ul"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          listStyle: 'none',
          mb: 0,
          p: 0
        }}
      >
        {renderLinks()}
      </MDBox>
    </MDBox>
  );
}

export default Footer;
